// Turnstile's api.js is loaded with render=explicit, so it never auto-renders.
// Rendering only from here keeps it to a single widget per container: when both
// ran, the two renders raced and one aborted the other's challenge request,
// leaving an empty token that the server could only reject.
//
// api.js is deferred and this pack is not, so whichever lands first drives the
// render: the callback below covers the usual order, the direct call covers a
// pack that executes after api.js has already run.
var ERROR_CLASS = 'cf-turnstile-error';
var ERROR_MESSAGE =
  'The security check could not be completed. Please refresh the page and ' +
  'try again, or contact us if it keeps happening.';

// Without this the challenge fails silently and the customer only finds out
// once the server has already rejected their submission.
function showTurnstileError() {
  var widgets = document.querySelectorAll('.cf-turnstile');

  for (var i = 0; i < widgets.length; i++) {
    if (widgets[i].parentNode.querySelector('.' + ERROR_CLASS)) continue;
    var message = document.createElement('p');
    message.className = ERROR_CLASS;
    message.setAttribute('role', 'alert');
    message.textContent = ERROR_MESSAGE;
    widgets[i].parentNode.insertBefore(message, widgets[i].nextSibling);
  }
}

function renderTurnstileWidgets() {
  if (!window.turnstile) return;

  var widgets = document.querySelectorAll('.cf-turnstile');

  for (var i = 0; i < widgets.length; i++) {
    if (widgets[i].getAttribute('data-rendered')) continue;
    widgets[i].setAttribute('data-rendered', 'true');
    window.turnstile.render(widgets[i]);
  }
}

export default function() {
  window.turnstileFailed = showTurnstileError;
  window.onloadTurnstileCallback = renderTurnstileWidgets;
  renderTurnstileWidgets();
}
